import { IEcommerceQuestionModelState, IEcommerceResponseValidation, EcommerceQuestionModelTypes } from './types'
import { IQuestionModelConstructor, QuestionType } from '../types'
import BaseQuestionModel from '../BaseQuestionModel'

const EcommerceQuestionModel: IQuestionModelConstructor<EcommerceQuestionModelTypes> = (questionSchema, action) => {
  const { model } = BaseQuestionModel<EcommerceQuestionModelTypes, IEcommerceQuestionModelState>({
    questionType: QuestionType.ECOMMERCE,
    questionSchema: questionSchema,
    action,
    submitResponse,
    initState,
    validateResponse,
    namedFrames: ['question']
  })
  return model
}

export function submitResponse({ response, questionSchema }: IEcommerceQuestionModelState) {
  const naAnswer = questionSchema.answers.find(a => a.na)
  const naChecked = response.answers.some(r => r.id == naAnswer?.id && r.v > 0)
  return response.answers
    .filter(answer => answer.v > 0 && (naChecked ? answer.id == naAnswer.id : true))
    .map(answer => {
      return { id: answer.id, v: answer.v, s: answer.subscribe }
    })
}

export function initState(state: IEcommerceQuestionModelState): IEcommerceQuestionModelState {
  state.response = {
    answers:
      state.questionSchema.store === 'amazonw'
        ? []
        : state.questionSchema.answers.map(a => {
            return { id: a.id, v: 0, price: (a.discounted_price ? a.discounted_price : a.price) || 0 }
          }),
    clicked: state.questionSchema.na
  }
  state.responseValidation = { valid: false }
  return state
}

function validateResponse({ response, questionSchema }: IEcommerceQuestionModelState): IEcommerceResponseValidation {
  return {
    valid: questionSchema.na
      ? response.answers.some(r => r.v > 0)
      : response.clicked || response.answers.some(r => r.v > 0)
  }
}

export default EcommerceQuestionModel
